module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerMixin('Grid_Lazy_Append', {
		configure: function(options) {
			console.log('connected lazy append');
			this.callParent('configure', arguments);
		}
	});
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/mixin/grid/lazyAppend.js
// module id = 211
// module chunks = 0